<script lang="ts">
	import { message } from '$lib/localization/messages';
	import { locale } from '$lib/localization/locale';
	import type { User } from 'firebase/auth';
	import { AuthEmailRequestError, requestVerificationEmail } from '$lib/authEmailsClient';

	export let user: User;
	export let buttonText: string | undefined = undefined;
	$: resolvedButtonText =
		buttonText ?? message($locale, 'common/ResendVerificationEmailButton', 'resend');
	export let buttonClass: string =
		'w-60 py-3 flex flex-row justify-center items-center text-sm font-semibold rounded shadow-lg text-zinc-300 bg-navy-800 hover:brightness-150';
	export let containerClass: string = 'flex flex-col items-center';
	export let messageClass: string = 'mt-2 min-h-4 text-xs text-green-400';
	export let showMessage: boolean = true;
	export let resendMessage: string = '';
	export let isLoading: boolean = false;

	const resendVerificationEmail = async (): Promise<void> => {
		if (!user || isLoading) return;

		isLoading = true;
		resendMessage = '';
		try {
			resendMessage = await requestVerificationEmail(user, $locale);
		} catch (error) {
			console.error('Error resending verification email:', error);
			resendMessage =
				error instanceof AuthEmailRequestError
					? error.message
					: message(
							$locale,
							'common/ResendVerificationEmailButton',
							'failedToSendVerificationEmailTryAgainLater'
						);
		} finally {
			isLoading = false;
		}
	};
</script>

<div class={containerClass}>
	<button type="button" class={buttonClass} on:click={resendVerificationEmail} disabled={isLoading}>
		<span class="inline-grid whitespace-nowrap">
			<span class="invisible col-start-1 row-start-1" aria-hidden="true">{resolvedButtonText}</span>
			<span class="invisible col-start-1 row-start-1" aria-hidden="true"
				>{message($locale, 'common/ResendVerificationEmailButton', 'sending')}</span
			>
			<span class="col-start-1 row-start-1"
				>{isLoading
					? message($locale, 'common/ResendVerificationEmailButton', 'sending')
					: resolvedButtonText}</span
			>
		</span>
	</button>

	{#if showMessage}
		<div class={messageClass} aria-live="polite">{resendMessage}</div>
	{/if}
</div>
